import AggregatedPortfolioContainer from "~components/portfolio/AggregatedPortfolioContainer"
import useAggregatedPortfolios from "~hooks/useAggregatedPortfolios"
import { FormProvider, useForm } from "react-hook-form"

interface Props {
  userId: string
  userName: string
}

const AggregatedPortfolio = ({ userId, userName }: Props) => {
  // The aggregated-portfolio endpoint returns each holding's security catalog
  // code under `id` (e.g. "nyse-ccl-2026"), whereas usePortfolioData matches on
  // `security.code`. Normalize so the quantities map onto the catalog rows.
  const extractAggregatedPortfolio = (rawData: any) => {
    if (!rawData?.holdings) return rawData
    return {
      ...rawData,
      holdings: rawData.holdings.map((holding: any) => ({
        ...holding,
        security: {
          ...holding.security,
          code: holding.security?.code ?? holding.security?.id,
        },
      })),
    }
  }

  const form = useForm()

  return (
    <FormProvider {...form}>
      <AggregatedPortfolioContainer
        userId={userId}
        userName={userName}
        fetcherHook={useAggregatedPortfolios}
        extractPortfolioData={extractAggregatedPortfolio}
      />
    </FormProvider>
  )
}

export default AggregatedPortfolio
